import {
  GridCellProps,
  Index,
  MultiGrid,
  MultiGridProps,
  Size,
} from 'react-virtualized';
import { hofForwardRef } from '../../utils/types';
import * as MultiGridUI from './MultiGridTableUI';

interface IProps
  extends Omit<MultiGridProps, 'columnWidth' | 'height' | 'width'> {
  columnCount: number;
  rowCount: number;
  cellRenderer: (props: GridCellProps) => React.ReactNode;
  rowHeight: number | ((params: Index) => number);
  fixedColumnCount?: number;
  columnWidthRenderer?: (params: Index) => number;
  onResize?: () => void;
}

export default hofForwardRef<IProps, MultiGrid>(
  (
    {
      columnCount,
      rowCount,
      cellRenderer,
      rowHeight = 32,
      columnWidthRenderer,
      fixedColumnCount = 0,
      onResize,
      ...restProps
    },
    ref,
  ) => {
    return (
      <MultiGridUI.TableAutoSizer onResize={onResize}>
        {({ height, width }: Size) => (
          <MultiGrid
            ref={ref}
            cellRenderer={cellRenderer}
            columnCount={columnCount}
            columnWidth={({ index }: Index) =>
              columnWidthRenderer ? columnWidthRenderer({ index }) : 120
            }
            fixedRowCount={1} // makes the header row sticky
            fixedColumnCount={fixedColumnCount} // makes the column cells sticky
            rowCount={rowCount + 1} // +1 for the header row
            rowHeight={rowHeight}
            height={height}
            width={width}
            onSectionRendered={onResize}
            enableFixedColumnScroll
            hideBottomLeftGridScrollbar
            {...restProps}
          />
        )}
      </MultiGridUI.TableAutoSizer>
    );
  },
);
